import React, { createContext, useCallback, useState } from 'react';
import { BreadcrumbItem } from '../../components/breadcrumbs/breadcrumbs';

export interface BreadcrumbsContextValue {
  items: BreadcrumbItem[] | null;
  setItems: (items: BreadcrumbItem[] | null) => void;
  clearItems: () => void;
}

export const BreadcrumbsContext = createContext<
  BreadcrumbsContextValue | undefined
>(undefined);

interface BreadcrumbsProviderProps {
  children: React.ReactNode;
}

export const BreadcrumbsProvider: React.FC<BreadcrumbsProviderProps> = ({
  children,
}) => {
  const [items, setItemsState] = useState<BreadcrumbItem[] | null>(null);

  const setItems = useCallback((newItems: BreadcrumbItem[] | null) => {
    setItemsState(newItems);
  }, []);

  const clearItems = useCallback(() => {
    setItemsState(null);
  }, []);

  const value: BreadcrumbsContextValue = {
    items,
    setItems,
    clearItems,
  };

  return (
    <BreadcrumbsContext.Provider value={value}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};
